const initTabsScript = (tabsEl) => {
    const nav = tabsEl.querySelector('[data-type="tabs-nav"]');
    const panels = tabsEl.querySelectorAll('[data-type="tab-panel"]');
    const buttons = tabsEl.querySelectorAll('[data-type="tab-btn"]');

    // Helper function to hide all panels
    const hideAllPanels = () => {
        panels.forEach((panel) => panel.classList.add('hidden'));
        buttons.forEach((btn) =>
            btn.classList.remove('border-b-2', 'border-blue-500', 'font-bold')
        );
    };

    // Show the first panel by default
    hideAllPanels();
    if (panels[0]) {
        panels[0].classList.remove('hidden');
        buttons[0].classList.add('border-b-2', 'border-blue-500', 'font-bold'); // minimal Tailwind for active tab
    }

    // Add click events to buttons
    buttons.forEach((btn, index) => {
        btn.addEventListener('click', () => {
            hideAllPanels();
            // Show corresponding panel
            const targetPanelId = btn.dataset.targetBtn.replace(
                'tab-btn',
                'tab-panel'
            );
            const targetPanel = tabsEl.querySelector(
                `[data-target-panel="${targetPanelId}"]`
            );
            if (targetPanel) targetPanel.classList.remove('hidden');

            // Highlight active button
            btn.classList.add('font-bold');
        });
    });
};

export default initTabsScript;
